import { Token } from '@emberswap/emberswap-sdk2/dist/entities'
import { Type } from '@emberswap/emberswap-sdk2/dist/types'
import { useMemo } from 'react'

import { getCurrencyCombinations } from '../functions/getCurrencyCombinations'
/**
 * @param {number}chainId
 * @param {Type}currencyA
 * @param {Type}currencyB
 * @param {'auto'|'custom'} pathType
 * @param {Token[]} custom
 * @return {[Token, Token][]}
 */
export function useCurrencyCombinations(
  chainId: number,
  currencyA?: Type,
  currencyB?: Type,
  pathType?: 'auto' | 'custom',
  custom?: Token[],
): [Token, Token][] {
  return useMemo(
    () => (chainId ? getCurrencyCombinations(chainId, currencyA, currencyB, pathType, custom) : []),
    [chainId, currencyA, currencyB, custom, pathType]
  )
}
